import { render } from "./BuyComplectSlider.vue?vue&type=template&id=f535f36c"
import script from "./BuyComplectSlider.vue?vue&type=script&lang=js"
export * from "./BuyComplectSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__